import { render, staticRenderFns } from "./vtmar.vue?vue&type=template&id=14a5880f&scoped=true&"
import script from "./vtmar.vue?vue&type=script&lang=js&"
export * from "./vtmar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a5880f",
  null
  
)

export default component.exports